import { render, staticRenderFns } from "./sort-by.vue?vue&type=template&id=55ae116b"
import script from "./sort-by.vue?vue&type=script&lang=js"
export * from "./sort-by.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ae116b')) {
      api.createRecord('55ae116b', component.options)
    } else {
      api.reload('55ae116b', component.options)
    }
    module.hot.accept("./sort-by.vue?vue&type=template&id=55ae116b", function () {
      api.rerender('55ae116b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/sort-by.vue"
export default component.exports